// extracted by mini-css-extract-plugin
module.exports = {"vars":"'../../vars.css'","accent":"#4E1617","secondary":"#C4942F","divider":"Divider-module--divider--3TfPz","dividerAccent":"Divider-module--dividerAccent--29jYH"};